export function getVatDefinitions() {
    return [
        { name: '23%', value: 23 },
        { name: '8%', value: 8 },
        { name: '5%', value: 5 },
        { name: '0%', value: 0 },
        { name: 'zw', value: 0 },
        { name: 'np', value: 0 },
    ];
}

export function getVatValue(name) {
    const definitions = getVatDefinitions();
    return definitions[definitions.findIndex(s => s.name === name)]?.value;
}

export function createVatDefinition(val) {
    const intValue =  parseInt(val, 10);
    if(isNaN(intValue) || intValue < 0 || intValue > 100) return { name: 'Błąd', value: 0 };
    return { name: intValue.toString()+'%', value: intValue };
}

export function getVatExtemptions() {
    return [
        { value: "BRAK_ZWOLNIENIA", label: "Podatnik nie jest zwolniony z VAT" },
        { value: "RODZAJ_DZIALALNOSCI", label: "Zwolnienie ze względu na rodzaj prowadzonej działalności" },
        { value: "ROZPORZADZENIE_MF", label: "Zwolnienie na mocy rozporządzenia MF" },
        { value: "NIEPRZEKROCZENIE_LIMITU", label: "Zwolnienie ze względu na nieprzekroczenie 200 000 PLN obrotu" },
        { value: "INNA_PODSTAWA", label: "Inna podstawa prawna" },
    ];
}